<template>
  <div class="row">
    <loading :active.sync="isLoading" :can-cancel="true" :opacity="0.85" :is-full-page="true"></loading>
    <div class="col-12">
      <card
        :title="title"
        :subTitle="subTitle"
        :showFilter="showFilter"
        @doFilter="doFilter"
        :filterInputValue="filterTerm"
      >
        <div slot="raw-content" class="table-responsive">
          <paper-table
            :data="displayData"
            :loading="loading"
            :columns="columns"
            :hasActions="hasActions"
            :actions="actions"
            :totalItems="totalItems"
            @changePage="changePage"
            @editClick="editClick"
            @deleteClick="deleteClick"
            @addClick="addClick"
            entityName="Agent"
          ></paper-table>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { PaperTable } from "@/components";
import { db } from "@/db";
import utils from "../../utils.js";
import store from "../../router/store";

const tableColumns = ["Name"];

export default {
  components: {
    PaperTable,
    Loading
  },
  data() {
    return {
      loading: true,
      title: "Agents",
      subTitle: `All agents are listed below`,
      hasActions: true,
      actions: {
        edit: true,
        delete: true
      },
      columns: [...tableColumns],
      allData: [],
      displayData: [],
      filteredData: [],
      isLoading: false,
      currentPage: 1,
      totalItems: 1,
      showFilter: true,
      filterTerm: ""
    };
  },
  watch: {
    allData: {
      immediate: true,
      handler(allData) {
        if (allData.length > 0) {
          this.loading = false;
        }

        this.filterData();
      }
    },
    filterTerm: {
      immediate: true,
      handler(filterTerm) {
        this.filterData();
      }
    }
  },
  firestore() {
    setTimeout(() => {
      this.loading = false;
    }, 3000);

    return {
      allData: db.collection("agents")
    };
  },
  methods: {
    loadPage(num) {
      this.isLoading = true;
      if (!num) num = this.currentPage;
      let take = 10;
      this.displayData = utils.paginate(this.filteredData, take, num);
      this.isLoading = false;
    },
    filterData() {
      var search = this.filterTerm.toUpperCase();
      var result = this.allData.filter(f => {
        return f.Name.toUpperCase().includes(search);
      });

      this.filteredData = result
        .sort(function(a, b) {
          return a.Name.toUpperCase() > b.Name.toUpperCase() ? 1 : -1;
        })
        .map(c => {
          return {
            Name: c.Name,
            Id: c.Id
          };
        });

      this.totalItems = this.filteredData.length;
      this.loadPage(1);
    },
    changePage(pageNum) {
      this.currentPage = pageNum;
      this.loadPage(pageNum);
    },
    doFilter(filter) {
      this.filterTerm = filter;
      this.loadPage(1);
    },
    editClick(id) {
      this.$router.push(`/editagent/${id}`);
    },
    addClick(id) {
      this.$router.push(`/addagent`);
    },
    customAction1Clicked(id) {
      this.$router.push(`/areas/${id}`);
    },
    deleteClick(id, description) {
      if (
        window.confirm(
          `Are you sure you want to delete the agent '${description}'?`
        )
      ) {
        this.isLoading = true;
        let self = this;
        this.isLoading = true;
        db.collection("agents")
          .doc(id)
          .delete()
          .then(() => {
            self.$helpers.dispatch("showSuccess", {
              msg: "Agent deleted successfully",
              vm: self
            });
          })
          .catch(err => {
            self.isLoading = false;
            self.$helpers.dispatch("showError2", {
              vm: self,
              err: err
            });
          });
      }
    }
  }
};
</script>
